import React from "react"
import styled from "styled-components"

const titleHeight = 50
const timeout = 300

const CollapseWrapper = styled.div<{
    show: boolean
}>`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: ${(props) => (props.show ? "100%" : `${titleHeight}px`)};
    transition: max-height ${timeout}ms;
`
const CollapseTitleWrapper = styled.div`
    display: flex;
    width: 100%;
    height: ${titleHeight}px;
    align-items: center;
    padding: 0 10px;
    background: ${(props) => props.theme.collapseTitleBackground};
    border-top: 1px solid ${(props) => props.theme.collapseTitleBorderTopColor};
    border-bottom: 1px solid ${(props) => props.theme.collapseTitleBorderBottomColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        background: ${(props) => props.theme.collapseTitleBackgroundHover};
        transition: ${(props) => props.theme.defaultTransition};
    }
`
const CollapseTitle = styled.div`
    width: 100%;
    text-transform: uppercase;
    cursor: pointer;
    font-weight: 600;
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    color: ${(props) => props.theme.collapseTitleColor};
`
const CollapseBodyWrapper = styled.div<{
    show: boolean
}>`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: ${(props) => (props.show ? "100%" : "0px")};
    overflow: hidden;
    background: ${(props) => props.theme.collapseBodyBackground};
    border-bottom: ${(props) => (props.show ? "1px" : 0)} solid ${(props) => props.theme.collapseBodyBorderColor};
    transition: max-height ${timeout}ms;
`


export interface CollapseProps {
    show: boolean
    title: any
    children: React.ReactNode
    onCollapse?: () => void
}

export const Collapse = ({
    show,
    title,
    children,
    onCollapse,
}: CollapseProps) => (
    <CollapseWrapper show={show}>
        <CollapseTitleWrapper onClick={onCollapse || null}>
            <CollapseTitle>{title}</CollapseTitle>
        </CollapseTitleWrapper>
        <CollapseBodyWrapper show={show}>{children}</CollapseBodyWrapper>
    </CollapseWrapper>
)
